module.exports = __webpack_public_path__ + "img/pc-bg03-mobile.388a657f.png";